import React, { useState, useRef, useEffect } from "react";
import me from './assets/me2.jpg';
import { Link } from 'react-router-dom';
import './about.css';
import emailjs from '@emailjs/browser';
import { LuFigma } from "react-icons/lu";
import { SiAdobephotoshop } from "react-icons/si";
import { SiBlender } from "react-icons/si";
import { SiAdobepremierepro } from "react-icons/si";
import { SiAdobeillustrator } from "react-icons/si";
import { BiLogoVisualStudio } from "react-icons/bi";
import procreate from './assets/Procreate.png';
import corel from './assets/draw.png';
import unbundl from './assets/unbundl.gif';
import suzano from './assets/gif1.gif';



const About = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []); //for scroll to the top always I mean whenever the page opens the page will be at the top

    const [isOverlayVisible, setOverlayVisible] = useState(false);

    const toggleOverlay = () => {
        setOverlayVisible(!isOverlayVisible);
    };

    // mouse cursor
    const [position, setPosition] = useState({ x: 0, y: 0 });
    const [hovered, setHovered] = useState(false);

    useEffect(() => {
        const handleMouseMove = (e) => {
            setPosition({ x: e.clientX, y: e.clientY });
        };

        document.addEventListener("mousemove", handleMouseMove);

        return () => {
            document.removeEventListener("mousemove", handleMouseMove);
        };
    }, []);

    const form = useRef();
    const [notification, setNotification] = useState("");

    const sendEmail = (e) => {
        e.preventDefault();

        // Get form data
        const formData = new FormData(form.current);
        const name = formData.get("user_name");
        const email = formData.get("user_email");
        const subject = formData.get("user_subject");
        const message = formData.get("message");

        // Check if any field is empty
        if (!name || !email || !subject || !message) {
            setNotification("All fields are required!");
            setTimeout(() => setNotification(""), 3000); // Hide notification after 3 seconds
            return;
        }

        emailjs
            .sendForm('service_mh1ddkn', 'template_2zi8jcs', form.current, 'dBrGazk0t-K47QR2W')
            .then(
                () => {
                    setNotification("Message sent successfully!");
                    form.current.reset(); // Reset form fields
                    setTimeout(() => setNotification(""), 3000); // Hide notification after 3 seconds
                },
                (error) => {
                    setNotification("Failed to send message. Try again!");
                    setTimeout(() => setNotification(""), 3000); // Hide notification after 3 seconds
                    console.log("FAILED...", error.text);
                }
            );
    };

    useEffect(() => {
        const clickableElements = document.querySelectorAll("button, a, .logo, svg");

        clickableElements.forEach((element) => {
            element.addEventListener("mouseenter", () => setHovered(true));
            element.addEventListener("mouseleave", () => setHovered(false));
        });

        return () => {
            clickableElements.forEach((element) => {
                element.removeEventListener("mouseenter", () => setHovered(true));
                element.removeEventListener("mouseleave", () => setHovered(false));
            });
        };
    }, []);

    return (
        <div className="about-container">
            <div className={`cursor ${hovered ? "cursor-hover" : ""}`} style={{ left: `${position.x}px`, top: `${position.y}px` }} />
            <div className="navbar" >
                <p onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}>pranav.</p>
                <svg onClick={toggleOverlay} width="30" height="25" viewBox="0 0 30 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <rect width="30" height="5" rx="2.5" fill="#101010" />
                    <rect y="10" width="30" height="5" rx="2.5" fill="#101010" />
                    <rect y="20" width="30" height="5" rx="2.5" fill="#101010" /></svg>

                <ul className={`overlay ${isOverlayVisible ? "show" : ""}`}>
                    <div className="anim">
                        <div className="dot-anim"></div>
                        <li><Link to="/">home.</Link></li>
                    </div>
                    <div className="anim">
                        <div className="dot-anim"></div>
                        <li><Link to="/allprojects">project.</Link></li>
                    </div>
                    <div className="anim">
                        <div className="dot-anim"></div>
                        <li><Link to="/about">about.</Link></li>
                    </div>
                    <div className="anim">
                        <div className="dot-anim"></div>
                        <li><Link to="/contact">contact.</Link></li>
                    </div>
                    <div className="available">
                        <div className="dot-green"></div>available for freelance.
                    </div>
                </ul>
            </div>
            <div className="hero">
                <div className="profile">
                    <img src={me}/>
                </div>
                <div className="contents">
                    <div className="scroll-down">
                        <div className="c1">
                            <h1>oh hey, <br /> you found me!</h1>
                            <p>that’s impressive i usually get lost in a maze of figma layers and after effects keyframes. 👀</p>
                        </div>
                        <div className="desc">
                            <p>i’m <b> pranav pradeep.</b> i have a bachelor’s degree in computer science engineering, but instead of debugging code, i decided to debug bad design choices. <br /> smart move right? “debatable.”</p>
                        </div>
                    </div>
                    <p className="youcanscroll">you can scroll down. 👀</p>
                </div>
            </div>

            <div className="current">
                <div className="details-1">
                    <p>Currently, I’m working at a Digital Marketing Agency/Studio called Unbundl (since Oct 23, 2023, in case you’re keeping track). </p>
                    <div className="division">
                        <h4>my job?</h4>
                        <p>making brands look cooler than they actually are. from ui/ux design to branding, 3d animation, and graphic design, i do it all. i even sketch because sometimes, you just need to put pencil to paper and pretend like you’re in the the classic artist era. or maybe you can just use an ipad to draw :p </p>
                    </div>
                </div>
                <div className="gif-container">
                    <p>unbundl logo</p>
                    <img src={unbundl} />
                </div>
            </div>

            <div className="current-one">
                <div className="suzano-container">
                    <img src={suzano} />
                </div>
                <div className="details-2">
                    <p>when i’m not pushing pixels or tweaking bezier curves, i’m probably overanalyzing font choices or pretending to be  a 3d modeling guru. </p>
                    <p>if you need a designer who drinks way too much coffee and obsesses over kerning, you’ve come to the right place! <br />let’s make something awesome. <br /> (or at least, something that doesn’t make people cringe) </p>
                    <button><Link to="/3d">check it out!</Link></button>
                </div>
            </div>

            <div className="current-two">
                <div className="threed-content">
                    <p>i have a fancy collection of tools i pretend to be a wizard with, and occasionally, google when i don’t know what i’m doing. </p>
                </div>

                <div className="icon-container">

                    <div className="top">
                        <div className="box-container">
                            <div className="box">
                                <LuFigma />
                            </div>
                            <div className="box">
                                <SiAdobephotoshop />
                            </div>
                        </div>
                        <div className="box-container">
                            <div className="box">
                                <SiBlender />
                            </div>
                            <div className="box">
                                <SiAdobepremierepro />
                            </div>
                        </div>
                        <div className="box-container">
                            <div className="box">
                                <img src={procreate} />
                            </div>
                            <div className="box">
                                <SiAdobeillustrator />
                            </div>
                        </div>
                        <div className="box-container">
                            <div className="box">
                                <BiLogoVisualStudio />
                            </div>
                            <div className="box">
                                <img src={corel} />
                            </div>
                        </div>
                    </div>

                </div>
            </div>

            <div className="sarcasm">
                <p>still scrolling?</p> <p>you must be really curious.</p> <p>👀</p>
            </div>

            <div className="sarcasm">
                <p>still here?</p> <p>you must really like me!</p><p>🙈</p>
            </div>

            <div className="sarcasm">
                <p>that’s it you can leave now!</p> <p>😉</p> 
            </div>

            <div className="missed-heading" id="contact">
                <h1>say hi.</h1>
                <div id="getintouch" className="sayhi">
                    <div className="contact-title">
                        <h1>let’s collaborate.</h1><br />
                        <p>have any idea in your mind?</p>
                        <p>fell free to reach out.</p>
                    </div>
                    <form className="contact" ref={form} onSubmit={sendEmail}>
                        <div className="textboxes">
                            <p>name.</p>
                            <input name="user_name" placeholder="John Doe" maxlength="25"></input>
                        </div>
                        <div className="textboxes">
                            <p>email.</p>
                            <input name="user_email" type="email" placeholder="example@gmail.com" maxlength="25"></input>
                        </div>
                        <div className="textboxes">
                            <p>subject.</p>
                            <input name="user_subject" placeholder="project abc" maxlength="25"></input>
                        </div>
                        <div className="textboxes">
                            <p>message.</p>
                            <input name="message" className="message" placeholder="I want your help in..." id=""></input>
                        </div>
                        <button type="submit" className="submit">submit.</button>
                    </form>
                </div>
            </div>

            <footer>
                <p>designed and developed by</p>
                <ul>pranav pradeep.</ul>
            </footer>
        </div>
    )
};
export default About;